import { StyleSheet } from 'react-native';
import { appTheme } from '@/config/colors';

export const styles = StyleSheet.create({
  full: {
    flex: 1,
  },
  addSetBtn: {
    marginHorizontal: -8,
  },
  addSetBtnContent: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  addSetBtnContentTxt: {
    marginLeft: 8,
    fontSize: 16,
    color: appTheme.primary,
  },
  rowWithNegativeMargin: {
    flexDirection: 'row',
    marginHorizontal: -4,
    gap: 8,
  },
});
